module.exports = __webpack_public_path__ + "img/chunks-11.e12f6fc5.jpg";